__turbopack_context__.v({
  "message": "LiovDq_message",
  "table": "LiovDq_table",
});
